/* ORIIVE — Recherche avancée (prédictive)
   Self-contained. Wires .oriive-header__search to a premium search overlay
   that queries Shopify Predictive Search (/search/suggest.json) live.
   Features: produits + collections + pages + suggestions de mots-clés,
   recherches récentes (localStorage), navigation clavier, compteur.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-oriive-search]');
  if (!root) return;

  var input       = root.querySelector('[data-search-input]');
  var form        = root.querySelector('.oriive-search__bar');
  var resultsPane = root.querySelector('[data-search-results]');
  var defaultPane = root.querySelector('[data-search-default]');
  var clearBtn    = root.querySelector('[data-search-clear]');
  var recentWrap  = root.querySelector('[data-search-recent]');
  var recentList  = root.querySelector('[data-search-recent-list]');
  var clearRecent = root.querySelector('[data-search-clearrecent]');
  var currency    = root.getAttribute('data-currency') || 'EUR';
  var locale      = root.getAttribute('data-locale') || 'fr';
  /* i18n: localized UI strings */
  var T = {
    'en': { suggestions:'Suggestions', collections:'Collections', products:'Products', pages:'Pages',
            noResults:'No results for', tryKeyword:'Try another keyword', seeAll:'See all results',
            productsLabel:'products', searchUnavailable:'Search temporarily unavailable',
            seeSearchPage:'Go to search page →', searchPlaceholder:'Search for a product, collection…' },
    'de': { suggestions:'Vorschläge', collections:'Kollektionen', products:'Produkte', pages:'Seiten',
            noResults:'Keine Ergebnisse für', tryKeyword:'Versuchen Sie ein anderes Wort', seeAll:'Alle Ergebnisse ansehen',
            productsLabel:'Produkte', searchUnavailable:'Suche vorübergehend nicht verfügbar',
            seeSearchPage:'Zur Suchseite →', searchPlaceholder:'Nach einem Produkt suchen…' }
  };
  var t = T[locale] || T['fr'] || {};
  var searchUrl   = (form && form.getAttribute('action')) || '/search';
  var openBtns    = document.querySelectorAll('.oriive-header__search, [data-search-open]');

  var RECENT_KEY = 'oriive_recent_searches', RECENT_MAX = 6;
  var lastFocus = null, debounceTimer = null, controller = null;
  var navItems = [], navIndex = -1;
  var fmt;
  try { fmt = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); } catch (e) { fmt = null; }

  /* ---------- helpers ---------- */

  /**
   * Format a price value from Shopify suggest.json.
   * suggest.json returns prices as decimal strings (e.g. "44.99" for 44,99 EUR),
   * NOT in cents. The value is already in the shop's major currency unit.
   *
   * @param {*} val - The price value (string "44.99" or number 44.99)
   * @returns {string} Formatted price string (e.g. "44,99 €")
   */
  function money(val) {
    if (val == null || val === '') return '';
    var s = String(val).trim();
    // Guard: if value is already a formatted currency string (e.g. "44,99 €"), return as-is
    if (/[€$£¥]/.test(s)) return s;
    // Parse: strip everything except digits, dot, comma, minus
    var cleaned = s.replace(/[^\d.,-]/g, '');
    // Handle European format "1.234,99" → swap to "1234.99"
    if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(cleaned)) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    }
    // Handle French format "44,99" → "44.99"
    else if (/^\d+,\d{1,2}$/.test(cleaned)) {
      cleaned = cleaned.replace(',', '.');
    }
    var n = parseFloat(cleaned);
    if (isNaN(n)) return '';
    // Shopify suggest.json returns prices in major units (EUR, not cents).
    // Guard: if the value looks suspiciously large (>10000 for a fashion store),
    // it might be in cents — divide by 100 as a safety net.
    if (n > 10000 && Math.abs(n - Math.round(n)) < 0.01) {
      n = n / 100;
    }
    return fmt ? fmt.format(n) : n.toFixed(2).replace('.', ',') + ' ' + currency;
  }

  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function highlight(text, q) {
    var t = esc(text); if (!q) return t;
    try {
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'i');
      return t.replace(re, '<b>$1</b>');
    } catch (e) { return t; }
  }
  function sized(url) {
    if (!url) return '';
    if (url.indexOf('cdn.shopify') > -1 && url.indexOf('width=') === -1) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    }
    return url;
  }
  function searchLink(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product,collection'; }

  /* ---------- recherches récentes ---------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = (q || '').trim(); if (q.length < 2) return;
    var list = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q); list = list.slice(0, RECENT_MAX);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecent() {
    if (!recentWrap || !recentList) return;
    var list = getRecent();
    if (!list.length) { recentWrap.hidden = true; recentList.innerHTML = ''; return; }
    recentList.innerHTML = list.map(function (q) {
      return '<a class="oriive-search__tag" href="' + searchLink(q) + '" data-recent-q="' + esc(q) + '">' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
        esc(q) + '</a>';
    }).join('');
    recentWrap.hidden = false;
  }

  /* ---------- ouverture / fermeture ---------- */
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  function open(e) {
    if (e) e.preventDefault();
    lastFocus = document.activeElement;
    renderRecent();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    setTimeout(function () { if (input) input.focus(); }, 70);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- rendu résultats ---------- */
  function render(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var queries     = r.queries || [];
    var collections = r.collections || [];
    var products    = r.products || [];
    var pages       = r.pages || [];
    var html = '';

    if (queries.length) {
      html += '<div class="oriive-search__group"><div class="oriive-search__label">' + (t.suggestions||'Suggestions') + '</div><div class="oriive-search__queries">';
      queries.slice(0, 4).forEach(function (s) {
        var txt = s.text || s.title || '';
        html += '<a class="oriive-search__query" href="' + searchLink(txt) + '">' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>' +
          '<span>' + highlight(txt, q) + '</span></a>';
      });
      html += '</div></div>';
    }

    if (collections.length) {
      html += '<div class="oriive-search__group"><div class="oriive-search__label">' + (t.collections||'Collections') + '</div><div class="oriive-search__cols">';
      collections.slice(0, 5).forEach(function (c) {
        html += '<a class="oriive-search__col" href="' + c.url + '">' + esc(c.title) + '</a>';
      });
      html += '</div></div>';
    }

    if (products.length) {
      html += '<div class="oriive-search__group"><div class="oriive-search__label">' + (t.products||'Produits') + '</div><div class="oriive-search__grid">';
      products.slice(0, 6).forEach(function (p) {
        var img = sized(p.image || (p.featured_image && p.featured_image.url) || '');
        var priceStr = money(p.price);

        // Compare-at price: use compare_at_price if available, else compare_at_price_max
        var compareRaw = p.compare_at_price || p.compare_at_price_max || '0.00';
        var compareVal = parseFloat(String(compareRaw).replace(/[^\d.,-]/g, '').replace(',', '.'));
        var priceVal = parseFloat(String(p.price).replace(/[^\d.,-]/g, '').replace(',', '.'));
        var hasCompare = !isNaN(compareVal) && !isNaN(priceVal) && compareVal > priceVal && compareVal > 0;
        var compareStr = hasCompare ? money(compareRaw) : '';

        html += '<a class="oriive-search__card" href="' + p.url + '">' +
          '<span class="oriive-search__thumb">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '</span>' +
          '<span class="oriive-search__metabox">' +
            '<span class="oriive-search__ptitle">' + esc(p.title) + '</span>' +
            '<span class="oriive-search__pricerow">' +
              (hasCompare ? '<span class="oriive-search__compare">' + compareStr + '</span>' : '') +
              '<span class="oriive-search__price' + (hasCompare ? ' oriive-search__price--sale' : '') + '">' + priceStr + '</span>' +
            '</span>' +
          '</span></a>';
      });
      html += '</div></div>';
    }

    if (pages.length) {
      html += '<div class="oriive-search__group"><div class="oriive-search__label">' + (t.pages||'Pages') + '</div><div class="oriive-search__cols">';
      pages.slice(0, 4).forEach(function (pg) {
        html += '<a class="oriive-search__col" href="' + pg.url + '">' + esc(pg.title) + '</a>';
      });
      html += '</div></div>';
    }

    if (!products.length && !collections.length && !queries.length && !pages.length) {
      html = '<div class="oriive-search__empty">' + (t.noResults||'Aucun résultat pour') + ' «&nbsp;' + esc(q) + '&nbsp;». ' + (t.tryKeyword||'Essayez un autre mot-clé') + '.</div>';
    } else {
      html += '<a class="oriive-search__all" href="' + searchLink(q) + '">' +
        (t.seeAll||'Voir tous les résultats') +
        (products.length ? ' <span class="oriive-search__count">(' + products.length + (products.length >= 6 ? '+' : '') + ' ' + (t.productsLabel||'produits') + ')</span>' : '') +
        ' →</a>';
    }
    resultsPane.innerHTML = html;
    collectNav();
  }

  /* ---------- navigation clavier ---------- */
  function collectNav() {
    navItems = [].slice.call(resultsPane.querySelectorAll('.oriive-search__query, .oriive-search__col, .oriive-search__card, .oriive-search__all'));
    navIndex = -1;
  }
  function moveNav(dir) {
    if (!navItems.length) return;
    if (navIndex > -1 && navItems[navIndex]) navItems[navIndex].classList.remove('is-active');
    navIndex += dir;
    if (navIndex < 0) navIndex = navItems.length - 1;
    if (navIndex >= navItems.length) navIndex = 0;
    var el = navItems[navIndex];
    el.classList.add('is-active');
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  /* ---------- requête ---------- */
  function run(q) {
    if (controller && controller.abort) controller.abort();
    controller = (window.AbortController) ? new AbortController() : null;
    root.classList.add('is-loading');
    var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,query&resources[limit]=8' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (res) { return res.json(); })
      .then(function (data) {
        root.classList.remove('is-loading');
        render(data, q);
        resultsPane.hidden = false;
        if (defaultPane) defaultPane.hidden = true;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        root.classList.remove('is-loading');
        resultsPane.innerHTML = '<div class="oriive-search__empty">' + (t.searchUnavailable||'Recherche momentanément indisponible') + '. <a href="' + searchLink(q) + '">' + (t.seeSearchPage||'Voir la page de recherche →') + '</a></div>';
        resultsPane.hidden = false;
        if (defaultPane) defaultPane.hidden = true;
        collectNav();
      });
  }
  function reset() {
    resultsPane.hidden = true; resultsPane.innerHTML = '';
    if (defaultPane) defaultPane.hidden = false;
    root.classList.remove('is-loading');
    navItems = []; navIndex = -1;
  }

  /* ---------- événements ---------- */
  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = !q;
      clearTimeout(debounceTimer);
      if (q.length < 2) { reset(); return; }
      debounceTimer = setTimeout(function () { run(q); }, 180);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveNav(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); moveNav(-1); }
      else if (e.key === 'Enter') {
        if (navIndex > -1 && navItems[navIndex]) { e.preventDefault(); saveRecent(input.value); window.location.href = navItems[navIndex].href; }
        else { saveRecent(input.value); /* le form submit suit */ }
      }
    });
  }
  if (form) form.addEventListener('submit', function () { saveRecent(input.value); });
  if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; reset(); input.focus(); });
  if (clearRecent) clearRecent.addEventListener('click', function () {
    try { localStorage.removeItem(RECENT_KEY); } catch (e) {} renderRecent();
  });

  // Sauvegarde de la requête au clic sur un résultat / une puce (avant navigation)
  root.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a') : null;
    if (!a) return;
    if (a.classList.contains('oriive-search__card') || a.classList.contains('oriive-search__col') ||
        a.classList.contains('oriive-search__all') || a.classList.contains('oriive-search__query')) {
      saveRecent(input ? input.value : '');
    }
    var rq = a.getAttribute('data-recent-q'); if (rq) saveRecent(rq);
  });

  openBtns.forEach(function (b) { b.addEventListener('click', open); });
  root.querySelectorAll('[data-search-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });
})();
